import {View} from 'MWC';
import PropTypes from 'prop-types';
import tpl from './templates/main.jsx';

export default class extends View {
    template = tpl;

    navigate = (...args) => {
        return this.context.app.navigate(...args);
    };

    static displayName = 'Footer';

    static contextTypes = {
        app: PropTypes.object
    };
}
